import * as React from "react"
import { useEffect } from "react"
import { Grid } from "@mui/material"

import { MANAGEMENT_ROUTES } from "@constants"
import PageWrapper from "Pages/@PageWrapper"
import {isLoadingCommonFilters, isSystemBusy} from "@signals";
import CustomersTable from "./CustomerTable";
import CustomersSiteTable from "./CustomerSitesTable";
import CustomersKeywordsTable from "./CustomerKeywordsTable";
import UserTable from "./UserTable";
import UserDrawer from "./UserDrawer";
import CustomerModulesPanel from "./CustomerModulesPanel";
import { resetManagementCustomerCrudsFilters } from "./@signals";


export default function ManagementCustomerCrudsPage() {

    useEffect(() => {
        return () => resetManagementCustomerCrudsFilters()
    }, [])

    useEffect(() => {
        isLoadingCommonFilters.value = true
    }, [])

    const props = {
        head: `DIP Insight | ${MANAGEMENT_ROUTES.CUSTOMER_CRUDS_TITLE}`,
        title: MANAGEMENT_ROUTES.CUSTOMER_CRUDS_TITLE,
        isEmpty: false,
        actions:null,
        hasErrors: isSystemBusy.value
    }

    return <PageWrapper {...props}>
        <Grid container spacing={2}>

            <Grid item xs={12}>
                <CustomersTable />
            </Grid>

            <Grid item xs={6}>
                <CustomersSiteTable />
            </Grid>

            <Grid item xs={6}>
                <CustomersKeywordsTable />
            </Grid>

            <Grid item xs={12}>
                <CustomerModulesPanel />
            </Grid>

            <Grid item xs={12}>
                <UserTable />
            </Grid>

            <Grid item xs={12}>
                <UserDrawer />
            </Grid>

        </Grid>
    </PageWrapper>
}